import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const isBrochure = pathname === '/brochure';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {!isBrochure && <Header />}
      <main className="flex-1" data-testid="main-content">{children}</main>
      {!isBrochure && <Footer />}
    </div>
  );
}
